export const LoadingState = () => {
    return (
      <div className="loader-state">
          <div className="state-loading"><span className="loader-two"></span></div>
          <center className="fixed-bottom title">ACADEMIA PREUNIVERSITARIA JUAN FANNING</center>
      </div>
    );
  }
  
  export default LoadingState;